import { Component, input, viewChild, inject, computed, OnInit, output } from '@angular/core';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';
import { NovaIcon } from '@rds-nova/angular-icon';
import { NovaButton } from '@rds-nova/angular-button';
import { RouterLink } from '@angular/router';
import { LanguageService } from '../../../../core/services/language.service';
import { Language } from '../../../../core/models/language.model';
import { TrackedButtonDirective } from 'src/app/core/analytics/directives/tracked-button.directive';
import { TrackedLinkDirective } from 'src/app/core/analytics/directives/tracked-link.directive';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  imports: [
    TranslatePipe,
    NovaButton,
    NovaIcon,
    MatMenuModule,
    RouterLink,
    TrackedButtonDirective,
    TrackedLinkDirective,
  ],
})
export class UserMenuComponent implements OnInit {
  userMenu = viewChild.required<MatMenu>('userMenu');
  exitSigningClicked = output();

  participantName = input.required<string>();
  showExitSigning = input<boolean>(true);
  showPhoneOption = input<boolean>(false);
  showLanguageOption = input<boolean>(false);
  showParticipantName = input<boolean>(true);
  phoneNumber = input<string>('');

  availableLanguages: Language[] = [];
  languageService = inject(LanguageService);

  currentLanguage = computed(() =>
    this.languageService.currentLanguage(),
  );

  getCurrentLanguageInfo = computed(() => {
    const current = this.currentLanguage();
    return (
      this.availableLanguages.find((lang) => lang.code === current) ||
      this.availableLanguages[0]
    );
  });

  get participantInitial(): string {
    const name = this.participantName();
    return name ? name.charAt(0).toUpperCase() : '';
  }

  ngOnInit(): void {
    this.availableLanguages = this.languageService.availableLanguages;
  }

  callSupport(): void {
    window.location.href = 'tel:' + this.phoneNumber();
  }

  selectLanguage(language: Language): void {
    this.languageService.setLanguage(language.code);
  }

  exitSigning(): void {
    this.exitSigningClicked.emit();
  }
}
